import React, { type ReactNode } from 'react'
import { useContainerWidth } from '@fs/zion-ui'

type ContentWrapperProps = Readonly<{
  children: ReactNode
}>

export default function ContentWrapper({ children }: ContentWrapperProps): JSX.Element {
  const atWidth = useContainerWidth()
  const isWide = atWidth({ default: false, xl: true })
  const style = isWide
    ? { height: 'calc(100vh - 210px)', overflowY: 'auto' as const, overflowX: 'hidden' as const }
    : { maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' as const, overflowX: 'hidden' as const }

  return <div style={style}>{children}</div>
}
